var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.3,
    height: 17.9,
    viewBox: "0 0 18.3 17.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1967",
    "data-name": "Trac\\xE9 1967",
    d: "M3.525,8.525c0-1.25.55-1.725,1.425-1.725s1.425.475,1.425,1.725v9.45c0,1.25-.55,1.725-1.425,1.725s-1.425-.475-1.425-1.725ZM.775,17.8c0,2.8,1.475,4.4,4.175,4.4s4.175-1.6,4.175-4.4V8.7c0-2.8-1.475-4.4-4.175-4.4S.775,5.9.775,8.7Zm9.95,0c0,2.8,1.475,4.4,4.175,4.4s4.175-1.6,4.175-4.4V14.6c0-2.575-1.025-4-3.05-4a2.529,2.529,0,0,0-2.5,1.525h-.05V8.95c0-1.675.55-2.15,1.525-2.15.875,0,1.425.475,1.425,1.725V9.15h2.6V8.7c0-2.8-1.4-4.4-4.1-4.4-2.85,0-4.2,1.6-4.2,4.55ZM14.9,13.1c.875,0,1.425.475,1.425,1.725v3.15c0,1.25-.55,1.7-1.425,1.7s-1.425-.45-1.425-1.7v-3.15C13.475,13.575,14.025,13.1,14.9,13.1Z",
    transform: "translate(-0.775 -4.3)",
    fill: "#73b9c5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon06);
export default __webpack_public_path__ + "static/media/icon-06.8e921a550645ddf512817761e5848f5e.svg";
export { ForwardRef as ReactComponent };